var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 10,
    fill: "#FF6201"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4971 17.7122C29.3251 18.2122 22.2931 21.2136 21.1224 21.7136C20.6304 21.9229 20.3304 22.3869 20.3304 22.9216C20.3304 28.7616 20.5638 31.3749 21.6224 34.3842C23.0078 38.3242 25.7278 41.4643 30.3304 44.0949C30.7398 44.3296 31.2544 44.3296 31.6638 44.0949C36.3078 41.4403 39.0398 38.3109 40.4131 34.3842C41.4585 31.3962 41.6638 28.9109 41.6638 22.9216C41.6638 22.3896 41.3611 21.9243 40.8718 21.7136L31.5811 17.7122C31.2451 17.5682 30.8331 17.5682 30.4971 17.7122Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc5);
export default __webpack_public_path__ + "static/media/ic-5.4e6811f83da3fb7558772aabf0a2dfce.svg";
export { ForwardRef as ReactComponent };